import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { installPromoteGtm } from './install-promote-gtm'
import { PromoteDirectSignupForm } from './promote-direct-signup-form'
import './promote.scss'

const IMG = '/promote'

const PromoteContainer = () => {
  const SignupForm = PromoteDirectSignupForm
  useEffect(() => {
    document.title = 'Request an invite · Credibila'
    const existing = document.getElementById('promote-inter-font')
    if (existing) return
    const link = document.createElement('link')
    link.id = 'promote-inter-font'
    link.rel = 'stylesheet'
    link.href =
      'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'
    document.head.appendChild(link)
  }, [])

  useEffect(() => installPromoteGtm(), [])

  return (
    <div className='promote-page' data-testid='promote-page'>
      <div className='promote-page__wrap'>
        <nav className='promote-page__nav'>
          <Link className='promote-page__brand' to='/'>
            <img src={`${IMG}/logo-v2.png`} alt='Credibila' />
          </Link>
          <div className='promote-page__nav-links'>
            <a className='promote-page__hide-m' href='#why'>
              Why now
            </a>
            <a className='promote-page__hide-m' href='#featured'>
              Featured companies
            </a>
            <a className='promote-page__btn promote-page__btn--sm' href='#join'>
              Request an invite
            </a>
          </div>
        </nav>

        <section className='promote-page__hero'>
          <div>
            <h1>Whoop, Inc. is now open for investment</h1>
            <p className='promote-page__lede'>
              Private companies are businesses you cannot buy on the stock market. Credibila lists
              them for individual investors, from US $100. Each listing is limited and opens
              briefly. Account holders hear about it first. Set up your account now, so when the
              next one opens you can act.
            </p>
            <div id='join'>
              <SignupForm formId='form1' />
            </div>
          </div>
          <div className='promote-page__side'>
            <div className='promote-page__wcard' data-testid='promote-whoop-card'>
              <div className='promote-page__wcard-head'>
                <span className='promote-page__wcard-name'>Whoop, Inc.</span>
                <span className='promote-page__wcard-live'>
                  <i /> Live
                </span>
              </div>
              <div className='promote-page__wcard-grid'>
                <div>
                  <span>Asset class</span>
                  <b>Private Equity</b>
                </div>
                <div>
                  <span>Min. investment</span>
                  <b>$100</b>
                </div>
                <div>
                  <span>Status</span>
                  <b className='promote-page__wcard-open'>Open</b>
                </div>
              </div>
            </div>
            <aside className='promote-page__hcard'>
              <div className='promote-page__k'>As of Oct 2026</div>
              <div className='promote-page__big'>US $30 million+</div>
              <div className='promote-page__bl'>assets under management on Credibila</div>
              <div className='promote-page__row3'>
                <div>
                  <b>[620]+</b>
                  <span>accounts opened</span>
                </div>
                <div>
                  <b>$100</b>
                  <span>minimum investment</span>
                </div>
                <div>
                  <b>First</b>
                  <span>account holders hear first</span>
                </div>
              </div>
            </aside>
          </div>
        </section>
      </div>

      <section className='promote-page__sec promote-page__sec--alt' id='why'>
        <div className='promote-page__wrap'>
          <div className='promote-page__k'>Why set up now</div>
          <h2>Limited availability. First come, first served.</h2>
          <p className='promote-page__fp'>
            Each listing on Credibila has a limited number of shares or units available. Once the
            allocation is fully subscribed, the listing closes.
          </p>
          <p className='promote-page__fp'>
            Account holders are notified before a listing goes live, giving you time to review the
            opportunity. To make the most of the allocation window, we recommend completing your
            profile and required verification in advance. Once a listing is open, eligible account
            holders can review the details and invest while availability remains.
          </p>
          <div className='promote-page__subh'>Three steps. Do the first two now.</div>
          <div className='promote-page__steps'>
            <div className='promote-page__stp'>
              <b>1</b>
              <h3>Enter your name and email</h3>
              <p>
                Or sign up with Google. We email you a link to verify your address and a temporary
                password for logging in on other devices. You can browse listings straight away.
              </p>
            </div>
            <div className='promote-page__stp'>
              <b>2</b>
              <h3>Complete your profile</h3>
              <p>
                Country and a few questions about your investing experience. Then you can see every
                company and every document.
              </p>
            </div>
            <div className='promote-page__stp'>
              <b>3</b>
              <h3>Invest when you choose to</h3>
              <p>
                When a listing opens, you are notified first. Review the details and decide.
                Identity verification is done once, when you choose to invest.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='promote-page__sec' id='featured'>
        <div className='promote-page__wrap'>
          <div className='promote-page__k'>Opportunities</div>
          <h2>Coming soon.</h2>
          <p className='promote-page__fp'>
            Listings in preparation. Not yet open. Account holders will be notified first when a
            listing goes live.
          </p>
          <div className='promote-page__logos'>
            <div className='promote-page__lg'>
              <div className='promote-page__lgbox'>
                <img src={`${IMG}/stripe.png`} alt='' />
                <span className='promote-page__wm'>Stripe</span>
              </div>
              <div className='promote-page__lgm'>Payments · United States · Secondary shares</div>
              <div className='promote-page__st promote-page__st--soon'>Coming soon</div>
            </div>
            <div className='promote-page__lg'>
              <div className='promote-page__lgbox'>
                <img src={`${IMG}/bricks.png`} alt='' />
                <span className='promote-page__wm'>Databricks</span>
              </div>
              <div className='promote-page__lgm'>
                Data and AI software · United States · Secondary shares
              </div>
              <div className='promote-page__st promote-page__st--soon'>Coming soon</div>
            </div>
          </div>
          <p className='promote-page__tiny'>
            These listings are not yet available and no offer is being made. Each is subject to
            final terms and may not proceed. Logos identify the companies only. They are not
            connected to Credibila and have not endorsed it.
          </p>
          <h2 className='promote-page__closed-heading'>Closed.</h2>
          <p className='promote-page__fp'>
            Listings that have been featured on Credibila and are now fully subscribed.
          </p>
          <div className='promote-page__logos'>
            <div className='promote-page__lg'>
              <div className='promote-page__lgbox'>
                <img src={`${IMG}/varak.png`} alt='' />
                <span className='promote-page__wm'>Varak</span>
              </div>
              <div className='promote-page__lgm'>
                The Edible Luxury · Confectionery and cafés · UAE
              </div>
              <div className='promote-page__st promote-page__st--done'>Closed</div>
            </div>
            <div className='promote-page__lg'>
              <div className='promote-page__lgbox'>
                <img src={`${IMG}/behari.png`} alt='' />
                <span className='promote-page__wm'>Behari Lal Engineering Limited</span>
              </div>
              <div className='promote-page__lgm'>Engineering · India</div>
              <div className='promote-page__st promote-page__st--done'>Closed</div>
            </div>
            <div className='promote-page__lg'>
              <div className='promote-page__lgbox'>
                <img src={`${IMG}/deepa.png`} alt='' />
                <span className='promote-page__wm'>Deepa Jewellers</span>
              </div>
              <div className='promote-page__lgm'>Jewellery · India</div>
              <div className='promote-page__st promote-page__st--done'>Closed</div>
            </div>
          </div>
          <p className='promote-page__tiny'>
            Logos identify companies previously featured on the platform. These companies are not
            connected to Credibila and have not endorsed it. A closed listing may or may not reopen.
            Nothing here is an offer, a recommendation, or a statement about how any investment has
            performed.
          </p>
        </div>
      </section>

      <section className='promote-page__sec'>
        <div className='promote-page__wrap'>
          <div className='promote-page__k'>Questions people ask</div>
          <div className='promote-page__faq'>
            <div>
              <h4>What is a private company?</h4>
              <p>
                A business whose shares are not traded on a stock exchange. You cannot buy it
                through a normal stock app. Many well-known companies are private.
              </p>
            </div>
            <div>
              <h4>Is $100 really the minimum?</h4>
              <p>Most listings open from US $100. Each listing states its own minimum.</p>
            </div>
            <div>
              <h4>Can I sell whenever I want?</h4>
              <p>
                Usually not. Private investments are illiquid. You should expect to hold them for
                years, and you may not be able to sell at all.
              </p>
            </div>
            <div>
              <h4>Can I lose money?</h4>
              <p>Yes. Private companies can fail. Only invest what you can afford to lose.</p>
            </div>
            <div>
              <h4>Does opening an account cost anything?</h4>
              <p>No. You only pay when you invest, and the fees are shown on each listing.</p>
            </div>
            <div>
              <h4>Why set up an account before a listing is open?</h4>
              <p>
                Listings have limited availability. Account holders are notified first. A complete
                profile and verification done in advance mean you can review and invest while
                availability remains.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className='promote-page__wrap'>
        <section className='promote-page__band'>
          <h2>Be ready for the next listing.</h2>
          <p>Account holders are told first. Set up now so you can act when it opens.</p>
          <SignupForm formId='form2' />
        </section>
        <div className='promote-page__foot-notice' id='notice'>
          <div className='promote-page__k'>Important notice</div>
          <p>
            Credibila Markets Ltd is incorporated and regulated in Mauritius and does not maintain
            an office or place of business in Dubai or the United Arab Emirates.
          </p>
          <p>
            The availability of meetings in Dubai should not be construed as establishing a branch,
            representative office or permanent presence of Credibila Markets Ltd in the UAE.
          </p>
          <p>
            Any meeting is intended to be introductory in nature and remains subject to applicable
            regulatory requirements and eligibility criteria. Nothing on this page constitutes an
            offer, solicitation, recommendation or financial advice in the UAE.
          </p>
        </div>
        <footer className='promote-page__foot'>
          Alternative investments are high-risk and illiquid. Capital at risk. For qualified
          investors only. Nothing on this page is an offer, solicitation or recommendation to
          invest. Credibila Markets is licensed by the Financial Services Commission, Mauritius, as
          a Full Service Dealer. <Link to='/terms_and_conditions'>Terms</Link> ·{' '}
          <Link to='/privacy_policy'>Privacy</Link> · <Link to='/disclaimer'>Risk disclosure</Link>
        </footer>
      </div>
    </div>
  )
}

export { PromoteContainer }
